import { ENV } from "@/utils";

type AnalyticsLinks = {
  [env: string]: {
    [key: string]: string;
  };
};

const POSTHOG_BASE_URL = "https://us.posthog.com";

export const ANALYTICS_LINKS: AnalyticsLinks = {
  DEV: {
    dropOff: `${POSTHOG_BASE_URL}/project/152605/insights/JBxFMCef`,
    avgAppTime24h: `${POSTHOG_BASE_URL}/project/152605/insights/n1Rppxrz`,
    avgAppTimeSession: `${POSTHOG_BASE_URL}/project/152605/insights/S9BCbePU`,
    revenueBySubscribers: `${POSTHOG_BASE_URL}/project/152605/insights/pWDmfByc`,
    amountOfUsersPerSubscriptions: `${POSTHOG_BASE_URL}/project/152605/insights/zgMejnrJ`,
    revenueBySubscription: `${POSTHOG_BASE_URL}/project/152605/insights/H837TUM1`,
    alfaCreatedDateNight: `${POSTHOG_BASE_URL}/project/152605/insights/5v2UpIXy`,
    alfaCreatedEvents: `${POSTHOG_BASE_URL}/project/152605/insights/5v2UpIXy`,
    userRoleDistribution: `${POSTHOG_BASE_URL}/project/152605/insights/VLSv5NLJ`,
    age: `${POSTHOG_BASE_URL}/project/152605/insights/DJ3B0vs8`,
    invitations: `${POSTHOG_BASE_URL}/project/152605/insights/IpILunOW`,
    revenueByCountry: `${POSTHOG_BASE_URL}/project/152605/insights/gsh1QzgX`,
    activeUsers: `${POSTHOG_BASE_URL}/project/152605/insights/Y2JbQPrY`,
  },
  STAGE: {
    dropOff: `${POSTHOG_BASE_URL}/project/152623/insights/LoT0IKJA`,
    avgAppTime24h: `${POSTHOG_BASE_URL}/project/152623/insights/79VcRZvT`,
    avgAppTimeSession: `${POSTHOG_BASE_URL}/project/152623/insights/uAGwUmi2`,
    revenueBySubscribers: `${POSTHOG_BASE_URL}/project/152623/insights/IvWJ6C4Q`,
    amountOfUsersPerSubscriptions: `${POSTHOG_BASE_URL}/project/152623/insights/LgiUKnRJ`,
    revenueBySubscription: `${POSTHOG_BASE_URL}/project/152623/insights/Oha4ovhw`,
    alfaCreatedDateNight: `${POSTHOG_BASE_URL}/project/152623/insights/je6biPUR`,
    alfaCreatedEvents: `${POSTHOG_BASE_URL}/project/152623/insights/je6biPUR`,
    userRoleDistribution: `${POSTHOG_BASE_URL}/project/152623/insights/GeM0CfRf`,
    age: `${POSTHOG_BASE_URL}/project/152623/insights/pvnb4VTw`,
    invitations: `${POSTHOG_BASE_URL}/project/152623/insights/bFs5Izl3`,
    revenueByCountry: `${POSTHOG_BASE_URL}/project/152623/insights/aC85T2Ky`,
    activeUsers: `${POSTHOG_BASE_URL}/project/152623/insights/UtMWleKu`,
  },
  PROD: {
    dropOff: `${POSTHOG_BASE_URL}/project/152621/insights/GoDPB6Xq`,
    avgAppTime24h: `${POSTHOG_BASE_URL}/project/152621/insights/lbbIwMHC`,
    avgAppTimeSession: `${POSTHOG_BASE_URL}/project/152621/insights/K27kPR4R`,
    revenueBySubscribers: `${POSTHOG_BASE_URL}/project/152621/insights/Yics4sDk`,
    amountOfUsersPerSubscriptions: `${POSTHOG_BASE_URL}/project/152621/insights/89cb2AK4`,
    revenueBySubscription: `${POSTHOG_BASE_URL}/project/152621/insights/w0WiRszA`,
    alfaCreatedDateNight: `${POSTHOG_BASE_URL}/project/152621/insights/onDl4mw5`,
    alfaCreatedEvents: `${POSTHOG_BASE_URL}/project/152621/insights/onDl4mw5`,
    userRoleDistribution: `${POSTHOG_BASE_URL}/project/152621/insights/wLLwXZDN`,
    age: `${POSTHOG_BASE_URL}/project/152621/insights/cBvqAOm4`,
    invitations: `${POSTHOG_BASE_URL}/project/152621/insights/znPDtXv3`,
    revenueByCountry: `${POSTHOG_BASE_URL}/project/152621/insights/pzaRSAWn`,
    activeUsers: `${POSTHOG_BASE_URL}/project/152621/insights/UbcZSFeN`,
  },
};

export const getAnalyticsLink = (key: string) =>
  ANALYTICS_LINKS[ENV.VITE_NODE]?.[key] || "";
